import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  CodeSelect,
  Button,
  ConditionBox,
  CustomInput,
  DatePickerField,
} from "components";
import moment from "moment";

const DeliveryTxnStatsCondition = (props) => {
  const { onClickSearch } = props;
  return (
    <>
      <ConditionBox>
        <Formik
          initialValues={{
            cretDate: moment().add(-1, "days"),
            srcfileCd: "",
            no1s: "",
          }}
          onSubmit={(values, { setSubmitting }) => {
            setSubmitting(true);
            const { cretDate, ...rest } = values;
            onClickSearch({
              ...rest,
              cretDate: moment(cretDate).format("YYYYMMDD"),
            });
            setSubmitting(false);
          }}
          validationSchema={Yup.object().shape({
            cretDate: Yup.date().required().nullable(),
          })}
        >
          {(props) => {
            const {
              values,
              touched,
              errors,
              isSubmitting,
              handleChange,
              handleBlur,
              handleSubmit,
            } = props;
            return (
              <form onSubmit={handleSubmit}>
                <div className="HasTable">
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <dl>
                            <dt>
                              발송일<i></i>
                              <span>
                                {errors.cretDate &&
                                  touched.cretDate &&
                                  errors.cretDate}
                              </span>
                            </dt>
                            <dd>
                              <div className="HasDate">
                                <DatePickerField
                                  name="cretDate"
                                  date={values.cretDate}
                                />
                              </div>
                            </dd>
                          </dl>
                          <dl>
                            <dt>구분</dt>
                            <dd>
                              <CodeSelect
                                codeId="SRCFILE_CD"
                                name="srcfileCd"
                                onChange={handleChange}
                                placeholder="원천구분 선택"
                                value={values.srcfileCd}
                              />
                            </dd>
                          </dl>
                          <dl>
                            <dt>수탁번호</dt>
                            <dd>
                              <CustomInput
                                name="no1s"
                                type="text"
                                placeholder="수탁번호 입력"
                                onChange={handleChange}
                                value={values.no1s}
                              />
                            </dd>
                          </dl>
                        </td>
                        <td>
                          <Button
                            type="submit"
                            className="inquire"
                            disabled={isSubmitting}
                          >
                            조회하기
                          </Button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </form>
            );
          }}
        </Formik>
      </ConditionBox>
    </>
  );
};

DeliveryTxnStatsCondition.propTypes = {};

export default DeliveryTxnStatsCondition;
